import httpClient from '../lib/http-client'
import { encrypt } from '../lib/utils'

const accountApi = {
  find () {
    return httpClient.get('/account')
  },
  add (model) {
    return httpClient.post('/account', {
      ...model,
      password: model.password ? encrypt(model.password, model.email) : null,
      passwordConfirm: model.passwordConfirm ? encrypt(model.passwordConfirm, model.email) : null
    })
  },
  findSignUpStatus () {
    return httpClient.get('/account/status')
  },
  updateInfo (model) {
    return httpClient.put('/account', {
      ...model,
      currentPassword: model.currentPassword ? encrypt(model.currentPassword, model.email) : null,
      newPassword: model.newPassword ? encrypt(model.newPassword, model.email) : null,
      newPasswordConfirm: model.newPasswordConfirm ? encrypt(model.newPasswordConfirm, model.email) : null
    })
  },
  requestEmail (model) {
    return httpClient.post('/account/email/request', model)
  },
  recoverPassword (model) {
    return httpClient.post('/account/password', model)
  },
  updatePassword (model) {
    return httpClient.put('/account/password', {
      ...model,
      newPassword: model.newPassword ? encrypt(model.newPassword, model.email) : null,
      newPasswordConfirm: model.newPasswordConfirm ? encrypt(model.newPasswordConfirm, model.email) : null
    })
  },
  emailFromToken (model) {
    return httpClient.post('/account/password/token', model)
  },
  removeUser () {
    return httpClient.delete('/account')
  },
  reApply () {
    return httpClient.put('/account/reapply')
  },
  checkEmail (email) {
    return httpClient.post('/account/email', { email })
  }
}

export default accountApi



// WEBPACK FOOTER //
// ./src/api/account.js